<template>
  <router-link
    v-if="isAnyFilterActive"
    :to="buildResetQuery"
    class="c-reset-filters__btn"
  >
    {{ getProductOverviewTranslations['ProductsOverview.ResetFilters'] }}
    <i class="far fa-times ml-2" />
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ResetFilters',
  computed: {
    ...mapGetters('productSearch', ['buildResetQuery', 'isAnyFilterActive']),
    ...mapGetters('translations', ['getProductOverviewTranslations'])
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/src/utilities/_variables.scss';
@import '@/css/src/utilities/_mixins.scss';
@import '~bootstrap/scss/mixins';

.c-reset-filters {
  &__btn {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    border-radius: 25px;
    padding: 10px 20px;
    border: 2px solid $grey;
    color: $grey;
    font-weight: $font-weight--bold;
    transition: background-color $transition-default-duration
      $transition-default-timing;

    @include remove-text-decoration($grey);

    &:hover {
      background-color: $white;
    }
  }
}
</style>
